<div class="template-details-modal">
  <div class="view-details-header">
    <div class="d-flex align-items-center gap-3">
      <div class="featured-icon {{data.iconColor}}">
        <span mwc-icon mwcIconfont={{data.icon}}></span>
      </div>
      <div>
        <div class="mwc-text-md-semibold mwc-color-gray-900">{{data.title}}</div>
        <div class="mwc-text-sm-regular mwc-color-gray-500">Workflow Details</div>
      </div>
    </div>
    <button class="view-details-close" mwc-tooltip mwcTooltipTitle="Close" (click)="close()">
      <span mwc-icon mwcIconfont="x-close"></span>
    </button>
  </div>
  <div mwc-row class="view-details-body">
    <div mwc-col [mwcSpan]="19" style="padding: 24px;">
      <div class="mwc-text-lg-medium mwc-color-gray-700 mb-2">Overview</div>
      <div class="mwc-text-sm-regular mwc-color-gray-500">{{data.summary}}</div>

      <div class="mwc-text-lg-medium mwc-color-gray-700 mt-3 mb-2">Why use this template</div>
      <div class="why-use-grid">
        <ng-container *ngFor="let whyUseText of data.whyUse; let i = index">
          <div class="why-use-card" *ngIf="getWhyUseParts(whyUseText) as parts">
            <div class="why-use-card__header">
              <div class="why-use-card__icon">
                <span mwc-icon [mwcIconfont]="i % 2 === 0 ? 'zap' : 'check-circle'"></span>
              </div>
              <div>
                <div class="why-use-card__title mwc-text-sm-medium mwc-color-gray-800">{{parts.title}}</div>
                <div class="why-use-card__desc mwc-text-sm-regular mwc-color-gray-500">{{parts.description}}</div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div mwc-col [mwcSpan]="5">
      <div class="view-details-actions">
        <button mwc-button mwcType="primary" mwcSize="small" mwcBlock (click)="startTemplate()">
          <span mwc-icon mwcIconfont="stars-02" style="font-size: 16px;"></span>
          Get Started
        </button>
        <button mwc-button mwcSize="small" mwcType="default" mwcBlock [mwcLoading]="isLoading" *ngIf="!data.isFavorite" (click)="toggleFavorite()">
          <span mwc-icon mwcIconfont="star-01" style="font-size: 16px;"></span>
          Mark as Favorite
        </button>
        <button mwc-button mwcSize="small" mwcType="default" mwcBlock [mwcLoading]="isLoading" *ngIf="data.isFavorite" (click)="toggleFavorite()">
          <div class="temp-star is-favorite">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
              <path d="M10.2141 0.308206C10.3849 -0.10244 10.9666 -0.10244 11.1374 0.308207L13.7325 6.54757C13.8045 6.72069 13.9673 6.83897 14.1542 6.85396L20.8902 7.39397C21.3335 7.42951 21.5133 7.98277 21.1755 8.2721L16.0434 12.6683C15.901 12.7902 15.8388 12.9816 15.8823 13.164L17.4503 19.7371C17.5535 20.1697 17.0828 20.5117 16.7033 20.2798L10.9364 16.7574C10.7764 16.6597 10.5752 16.6597 10.4152 16.7574L4.64827 20.2798C4.26872 20.5117 3.79809 20.1697 3.90129 19.7371L5.46922 13.164C5.51272 12.9816 5.45053 12.7902 5.30814 12.6683L0.176081 8.2721C-0.161688 7.98277 0.0180759 7.42951 0.461403 7.39397L7.19732 6.85396C7.38422 6.83897 7.54702 6.72069 7.61902 6.54757L10.2141 0.308206Z"/>
            </svg>
          </div>
          Remove from Favorites
        </button>
      </div>
      <div class="view-details-categories">
        <div class="view-details-categories__heading">
          <div class="view-details-categories__icon">
            <span mwc-icon mwcIconfont="tag-01"></span>
          </div>
          <span class="mwc-text-md-medium mwc-color-gray-700">Categories</span>
        </div>
        <div class="d-flex flex-wrap gap-1">
          <ng-container *ngFor="let categories of data.templateCategories">
            <mwc-tag [mwcColor]="'gray'" class="m-0" [title]="categories">
              <span class="categorie-name">{{categories}}</span>
            </mwc-tag>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
